import createBranchReducer from './create-branch-reducer';

export default createBranchReducer;
